<template>
     <div>
          <v-app-bar
               id="home-app-bar"
               app
               color="white"
               elevation="1"
               absolute
               height="80"
          >
               <v-spacer />
               <base-img
                    :src="require('@/assets/images/logo.jpg')"
                    contain
                    max-width="52"
                    width="100%"
               />
               <h2>Katinks Trinkets</h2>

               <v-spacer />
          </v-app-bar>
     </div>
</template>

<script>
export default {
     name: 'HomeAppBar',

     components: {
          HomeDrawer: () => import('./Drawer'),
     },
     data: () => ({
          drawer: null,
          items: [
               {
                    name: 'Home',
                    route: '/',
               },
          ],
     }),
}
</script>

<style lang="sass">
#home-app-bar
.v-tabs-slider
     max-width: 24px
     margin: 0 auto

.v-tab
     &::before
          display: none
</style>
